module.exports = __webpack_public_path__ + "static/media/tan-s-35.2757d398.png";